import React, { useEffect, useRef } from "react";
import CustomInput from "../components/CustomInput";
import ReactQuill from "react-quill";
import Dropzone from "react-dropzone";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { useFormik } from "formik";
import { useLocation, useNavigate } from "react-router-dom";
import * as yup from "yup";
import { uploadImg, delImg } from "../features/upload/uploadSlice";
import {
  createEvent,
  getAnEvent,
  resetState,
  updateAnEvent,
} from "../features/events/eventSlice";

const eventSchema = yup.object().shape({
  title: yup.string().required("Title is required"),
  description: yup.string().required("Description is required"),
  startDate: yup.date().required("Start date is required"),
  endDate: yup.date().required("End date is required"),
  startTime: yup.string().required("Start time is required"),
  endTime: yup.string().required("End time is required"),
  city: yup.string().required("City is required"),
  venue: yup.string().required("Venue is required"),
  speaker: yup.string().required("Speaker is required"),
  price: yup.number().required("Price is required"),
});


const AddEvent = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const getEventId = location.pathname.split("/")[3];

  const isInitialRender = useRef(true);
  const eventState = useSelector((state) => state.events);
  const imgState = useSelector((state) => state.upload.images);
  const imgIsSuccess = useSelector((state) => state.upload.isSuccess);
  const imgIsError = useSelector((state) => state.upload.isError);
  const isUploading = useSelector((state) => state.upload.isLoading);

  const {
    isSuccess,
    isError,
    isLoading,
    createdEvent,
    updatedEvent,
    eventData,
  } = eventState;
  

  useEffect(() => {
    if (getEventId) {
      dispatch(getAnEvent(getEventId));
    } else {
      dispatch(resetState());
    }
  }, [getEventId]);


    const handleImageDelete = (public_id) => {
      const updatedImages = formik.values.images.filter(
        (image) => image.public_id !== public_id
      );
      
      formik.setFieldValue("images", updatedImages);
    };
  
    useEffect(() => {
      if (isInitialRender.current) {
        isInitialRender.current = false; // Prevent toast on initial fetch
        return;
      }
    
      if (imgIsSuccess && imgState.length > 0) {
        toast.success("Image uploaded successfully!", {
          autoClose: 4000,
        });
        formik.setFieldValue("images", imgState);
      }
    
      if (imgIsError) {
        toast.error("Image upload failed. Please try again.", {
          autoClose: 4000,
        });
      }
    }, [imgIsSuccess, imgIsError, imgState]);

 

  useEffect(() => {
    if (isSuccess && createdEvent) {
      toast.success("Event Added Successfully!");
      setTimeout(() => navigate("/admin/event-list"), 2000);
    }
    if (isSuccess && updatedEvent) {
      toast.success("Event Updated Successfully!");
      setTimeout(() => navigate("/admin/event-list"), 2000);
    }
    if (isError) {
      toast.error("Something went wrong!");
    }
  }, [isSuccess, isError, isLoading]);

  console.log(eventData,"events")
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      title: eventData?.title || "",
      description: eventData?.description || "",
      startDate: eventData?.startDate || "",
      endDate: eventData?.endDate || "",
      startTime: eventData?.startTime || "",
      endTime: eventData?.endTime || "",
      city: eventData?.city || "",
      venue: eventData?.venue || "",
      type: eventData?.type || "general",
      speaker: eventData?.speaker || "",
      seatsLeft: eventData?.seatsLeft || "",
      courseLength: eventData?.courseLength || "",
      classDuration: eventData?.classDuration || "",
      price: eventData?.price || 0,
      images: eventData?.images || [],
     },
    
    validationSchema: eventSchema,
    onSubmit: (values) => {
      console.log(values,"values")
      if (getEventId) {
        dispatch(updateAnEvent({ id: getEventId, eventData: values }));
        formik.resetForm({
          values: {
            ...formik.initialValues,
            images: [], 
          },
        });
      } else {
        dispatch(createEvent(values));
        formik.resetForm({
          values: {
            ...formik.initialValues,
            images: [], // Clear images after submission
          },
        });
      }
      dispatch(resetState());
    },
  });

  return (
    <div>
      <h3 className="mb-4 title">{getEventId ? "Edit" : "Add"} Event</h3>
      <form onSubmit={formik.handleSubmit}>
        <CustomInput label="Title" name="title" val={formik.values.title} onChng={formik.handleChange("title")} onBlr={formik.handleBlur("title")} />
        <div className="error">{formik.touched.title && formik.errors.title}</div>

        <CustomInput label="City" name="city" val={formik.values.city} onChng={formik.handleChange("city")} onBlr={formik.handleBlur("city")} />
        <CustomInput label="Venue" name="venue" val={formik.values.venue} onChng={formik.handleChange("venue")} onBlr={formik.handleBlur("venue")} />

        <CustomInput type="date" label="Start Date" name="startDate" val={formik.values.startDate} onChng={formik.handleChange("startDate")} />
        <CustomInput type="date" label="End Date" name="endDate" val={formik.values.endDate} onChng={formik.handleChange("endDate")} />
        <CustomInput
          type="time"
          label="Start Time"
          name="startTime"
          val={formik.values.startTime}
          onChng={formik.handleChange("startTime")}
        />
        <CustomInput
          type="time"
          label="End Time"
          name="endTime"
          val={formik.values.endTime}
          onChng={formik.handleChange("endTime")}
        />

        <CustomInput label="Speaker" name="speaker" val={formik.values.speaker} onChng={formik.handleChange("speaker")} />
        <CustomInput label="Seats Left" name="seatsLeft" val={formik.values.seatsLeft} onChng={formik.handleChange("seatsLeft")} />
        <CustomInput label="Course Length" name="courseLength" val={formik.values.courseLength} onChng={formik.handleChange("courseLength")} />
        <CustomInput label="Class Duration" name="classDuration" val={formik.values.classDuration} onChng={formik.handleChange("classDuration")} />

        <CustomInput type="number" label="Price" name="price" val={formik.values.price} onChng={formik.handleChange("price")} />

        <select
          name="type"
          className="form-control py-3 mt-3"
          value={formik.values.type}
          onChange={formik.handleChange("type")}
        >
          <option value="general">General</option>
          <option value="certification">Certification</option>
          <option value="symposium">Symposium</option>
        </select>

        <label className="mt-3">Description</label>
        <ReactQuill theme="snow" value={formik.values.description} onChange={(val) => formik.setFieldValue("description", val)} />

          <div className="bg-white border-1 p-5 text-center mt-3">
            <Dropzone
              onDrop={(acceptedFiles) => dispatch(uploadImg(acceptedFiles))}
            >
              {({ getRootProps, getInputProps }) => (
                <section>
                  <div {...getRootProps()}>
                    <input {...getInputProps()} />
                    <p>
                      Drag 'n' drop some files here, or click to select files
                    </p>
                  </div>
                </section>
              )}
            </Dropzone>
          </div>
           <div
        className={`showimages d-flex flex-wrap gap-3 ${
          isUploading ? "loading-border " : ""
        }`}
      >
        {formik.values.images &&
          formik.values.images.map((image, index) => (
            <div className="image-card position-relative" key={index}>
              <button
                type="button"
                onClick={() => handleImageDelete(image.public_id)}
                className="btn-close position-absolute"
                style={{ top: "10px", right: "10px" }}
              ></button>
              <img src={image.url} alt="" width="100%" height={200} />
            </div>
          ))}
      </div>


        <button className="btn btn-success border-0 rounded-3 my-5" type="submit">
          {getEventId ? "Edit" : "Add"} Event
        </button>
      </form>
    </div>
  );
};

export default AddEvent;
